import { useState } from 'react'

// [value, setValue] backed by localStorage, same call shape as useState
// (setValue accepts a value or an updater function). JSON-encodes by default;
// pass { raw: true } for a key that's stored as a bare string (not JSON).
export const useLocalStorage = (key, defaultValue, { raw = false } = {}) => {
  const read = () => {
    try {
      const stored = localStorage.getItem(key)
      if (stored == null) return defaultValue
      return raw ? stored : JSON.parse(stored)
    } catch {
      return defaultValue
    }
  }

  const [value, setValue] = useState(read)

  const set = (next) => {
    setValue((prev) => {
      const resolved = typeof next === 'function' ? next(prev) : next
      try {
        localStorage.setItem(key, raw ? resolved : JSON.stringify(resolved))
      } catch {
        // ignore (private mode / storage disabled)
      }
      return resolved
    })
  }

  return [value, set]
}
